module.exports = __webpack_public_path__ + "static/media/icon-line-game.f72b00a0.svg";